import { MainNavMenuAsButton, MainNavMenuLink } from "@compono/ui";
import { ShowIf } from "../auth";
import { useOrganisation } from "~/auth-layer";
import { env } from "~/env";
import { GraduationHatSolidIcon } from "@compono/ui-icons";

export const DevelopNav = () => {
  const [org] = useOrganisation();
  return (
    <MainNavMenuAsButton
      icon={GraduationHatSolidIcon}
      label="Develop"
      data-menu-button="true"
    >
      <MainNavMenuLink href={`/courses`} label="Courses" />
      <ShowIf allowedTo="develop.learningPortal">
        <MainNavMenuLink
          href={`https://${org.id}.${env.CLUI_DOMAIN}/sso`}
          label="Learning portal"
          target="_blank"
        />
      </ShowIf>
    </MainNavMenuAsButton>
  );
};
